import { CompaniaService } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const CompaniaManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();
  const buscarPorId = (Id) => {
    return CompaniaService.buscarPorId(Id).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const actualizar = (compania) => {
    const filesArr = [];
    if (Array.isArray(compania.Logo) && compania.Logo[0]) filesArr.push(compania.Logo[0]);
    if (compania.Certificado) filesArr.push(compania.Certificado[0]);

    return CompaniaService.actualizar({
      ...compania,
      Files: filesArr,
    }).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const bloquearCancelarCompania = (compania) => {
    return CompaniaService.bloquearCancelarCompania(compania).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const listado = (where) => {
    return CompaniaService.listado(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const listarHijas = (where) => {
    return CompaniaService.listarHijas(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const crear = (compania) => {
    const filesArr = [];
    if (Array.isArray(compania.Logo) && compania.Logo[0]) filesArr.push(compania.Logo[0]);
    return CompaniaService.crear({
      ...compania,
      Files: filesArr,
    }).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const editar = (compania) => {
    const filesArr = [];
    if (Array.isArray(compania.Logo) && compania.Logo[0]) filesArr.push(compania.Logo[0]);
    return CompaniaService.editar({
      ...compania,
      Files: filesArr,
    }).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const editarVinculada = (compania) => {
    return CompaniaService.editarVinculada(compania).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const listadoDatosCertificado = () => {
    return CompaniaService.listarDatosCertificado().then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };


  const vincularCuentaQuickbooks = (data) => {
    return CompaniaService.vincularCuentaQuickbooks(data).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };


  const devincularCuentaQuickbooks = (data) => {
    return CompaniaService.devincularCuentaQuickbooks(data).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const desvincularQuickbooksPorRealmId = (realmId) => {
    return CompaniaService.desvincularQuickbooksPorRealmId(realmId).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const obtenerURLQuickbooks = () => {
    return CompaniaService.obtenerURLQuickbooks().then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const ObtenerInformacionCuentaQuickbooks = () => {
    return CompaniaService.ObtenerInformacionCuentaQuickbooks().then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const crearEnProduccion = (id, forzarIdAutomatico = false) => {
    return CompaniaService.crearEnProduccion(id, forzarIdAutomatico).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const exportarExcel = (where) => {
    return CompaniaService.exportarExcel(where).then((res) => {
      return res;
    });
  };

  return {
    buscarPorId,
    actualizar,
    bloquearCancelarCompania,
    listado,
    listarHijas,
    crear,
    crearEnProduccion,
    editar,
    editarVinculada,
    listadoDatosCertificado,
    vincularCuentaQuickbooks,
    obtenerURLQuickbooks,
    ObtenerInformacionCuentaQuickbooks,
    devincularCuentaQuickbooks,
    desvincularQuickbooksPorRealmId,
    exportarExcel
  };
})();
